<section class="feedback-list-page">
  <div class="feedback-list-header">
    <h1>{{ isMyFeedback ? 'My Feedback' : 'Anonymous Feedback List' }}</h1>
    <div class="feedback-list-actions">
      @if (isAdmin && !isMyFeedback) {
        <button
          mat-raised-button
          color="primary"
          (click)="exportFeedback()"
          [disabled]="isExcelExporting || isLoading"
        >
          @if (isExcelExporting) {
            <span class="spinner-size">
              <mat-spinner [diameter]="18"></mat-spinner>
            </span>
          }
          {{ isExcelExporting ? 'Exporting...' : 'Export Excel' }}
        </button>
      }
      @if(!isAdmin){
      <button mat-button [routerLink]="['/home/anonymous-feedback']">Add Feedback</button>
      }
    </div>
  </div>

  @if (isAdmin || isMyFeedback) {
    <div class="table-wrapper">
       <mat-paginator [length]="totalItemsCount" [pageSize]="pageSize" 
        [pageSizeOptions]="pageSizeOptions" showFirstLastButtons 
        (page)="onPageChange($event)"></mat-paginator>
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z4">
        <ng-container matColumnDef="submittedOn">
          <th mat-header-cell *matHeaderCellDef>Submitted On</th>
          <td mat-cell *matCellDef="let element">
            {{ element.createdDate | date:'dd-MM-yyyy HH:mm' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="feedback">
          <th mat-header-cell *matHeaderCellDef>Feedback</th>
          <td mat-cell *matCellDef="let element" class="feedback-text">
            {{ element.feedback }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      @if (!isLoading && dataSource.data.length === 0) {
        <p class="empty-message">
          {{ isMyFeedback ? 'You have not submitted feedback yet.' : 'No feedback found.' }}
        </p>
      }
    </div>
  }

</section>
